import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import Input from 'components/common/Input';

const ArticleBasic = () => {
 const {
  register,
  formState: { errors }
 } = useFormContext();

 return (
  <Card className="mb-3">
   <Card.Header as="h6" className="bg-body-tertiary">
    Información básica
   </Card.Header>
   <Card.Body>
    <Row className="gx-2 gy-3">
     <Input
      type="text"
      label="Nombre del articulo:"
      name="name"
      errors={errors}
      formGroupProps={{ as: Col, md: 6 }}
      formControlProps={{ ...register('name'), readOnly: false }}
     />

     <Input
      type="text"
      label="Identificación:"
      name="identification"
      errors={errors}
      formGroupProps={{ as: Col, md: 6 }}
      formControlProps={{ ...register('identification'), readOnly: false }}
     />

     <Input
      type="text"
      label="Fabricante:"
      name="manufacturer"
      errors={errors}
      formGroupProps={{ as: Col, md: 12 }}
      formControlProps={{ ...register('manufacturer'), readOnly: false }}
     />

     <Input
      type="text"
      label="Resumen del articulo:"
      name="summary"
      errors={errors}
      formGroupProps={{ as: Col, md: 12 }}
      formControlProps={{ ...register('summary'), readOnly: false }}
     />
    </Row>
   </Card.Body>
  </Card>
 );
};

export default ArticleBasic;
